import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * @description 全局 UI store
 *  - searchOpen: Ctrl+K 搜索弹窗开关
 */
export const useUIStore = defineStore('ui', () => {
  const searchOpen = ref(false)

  function openSearch() {
    searchOpen.value = true
  }

  function closeSearch() {
    searchOpen.value = false
  }

  return { searchOpen, openSearch, closeSearch }
})